import styled from 'styled-components';
import { theme, Text } from '@gympass/yoga';

export const Container = styled.div`
  text-align: center;
`;

export const RedeemButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${theme.spacing.large}px 0 ${theme.spacing.small}px;
`;

export const Title = styled(Text.H4)`
  margin-top: ${theme.spacing.large}px;
  margin-bottom: ${theme.spacing.xxsmall}px;
`;

export const Subtitle = styled(Text.Body2)`
  margin-bottom: ${theme.spacing.large}px;
  color: ${theme.colors.deepNew};
`;
